import React, { useMemo } from 'react'
import ConfirmationDialog from '../../../../../CommonComponents/confirmation_dialog/ConfirmationDialog'
import useModal from '../../../hooks/useModal'

const ConfirmationModal = () => {
    const { modals, setModals } = useModal()
    const dialouge = useMemo(() => modals.dialouge, [modals.dialouge])
    const closeModal = () => setModals((prev) => ({ ...prev, dialouge: null }))
    return (
        <ConfirmationDialog
            open={dialouge ? true : false}
            type={dialouge?.type || 'discard'}
            title={dialouge?.title || 'Discard Scenario Creation?'}
            description={dialouge?.description || 'Discarding this draft will result in the loss of all scenario data.'}
            onConfirm={dialouge?.onConfirm || closeModal}
            loading={dialouge?.loading || false}
            onCancel={dialouge?.onCancel || closeModal}
            onDiscard={dialouge?.onDiscard || closeModal}
            cancel_button_text={dialouge?.cancel_button_text || 'Cancel'}
            confirm_button_text={dialouge?.confirm_button_text || 'Save As Draft'}
        />
    )
}

export default ConfirmationModal